'use client';

import { ArrowLeftIcon } from '@radix-ui/react-icons';
import { Text, Card, Flex, Box } from '@radix-ui/themes';
import Link from 'next/link';
import { useEffect, useMemo, useState } from 'react';

interface Props {
  topicName: string;
}

export const BackToProblemListCardButton = ({ topicName }: Props) => {
  //Предотвращаем проблему с гидратацией
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const previousUrl = useMemo(
    () => (isClient ? localStorage.getItem('previousUrl') : ''),
    [isClient]
  );

  return (
    <Box width={{ initial: '100%', sm: '400px' }}>
      <Card asChild>
        <Link
          href={previousUrl || '/'}
          passHref
        >
          <Flex
            direction='column'
            gap='2'
          >
            <Text
              as='div'
              size='2'
              weight='bold'
            >
              Готовы применить знания на практике?
            </Text>
            <Flex
              align='center'
              gap='4'
            >
              <ArrowLeftIcon />
              <Box width={{ initial: '100%', sm: '350px' }}>
                <Text
                  as='div'
                  color='gray'
                  size='2'
                >
                  Вернуться к задачам по теме «{topicName}»
                </Text>
              </Box>
            </Flex>
          </Flex>
        </Link>
      </Card>
    </Box>
  );
};

export default BackToProblemListCardButton;
